export const GATEWAY_AUTH_METHOD_HEADER = 'ai-gateway-auth-method' as const;
export const VERCEL_AI_GATEWAY_TEAM_HEADER =
  'x-vercel-ai-gateway-team' as const;
